import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { SERPPreviewSource } from 'sources'

@createActions(alt)
export default class SERPPreviewActions {
  constructor() {
    this.generateActions(
      'setFetchingPreviews',
      'setFetchedPreviews'
    )
  }

  fetch(url) {
    //this.setFetchingPreviews(true)
    return SERPPreviewSource.fetch(url)
      .then(resp => this.setFetchedPreviews(resp))
  }

  fetchShopify(resource, limit, page) {
    //this.setFetchingPreviews(true)
    return SERPPreviewSource.fetchShopify(resource, limit, page)
      .then(resp => this.setFetchedPreviews(resp))
  }
}



// WEBPACK FOOTER //
// ./app/actions/SERPPreviewActions.js